import React from 'react';
import { Link, useLocation } from 'react-router-dom';

type LandingFooterProps = {
  t: (key: any) => string;
  language: 'EN' | 'RU';
  onToggleLanguage: () => void;
  isLightTheme: boolean;
  onToggleTheme: () => void;
  onGetAccess: () => void;
};

export const LandingFooter: React.FC<LandingFooterProps> = ({
  t,
  language,
  onToggleLanguage,
  isLightTheme,
  onToggleTheme,
  onGetAccess,
}) => {
  const location = useLocation();
  const telegramMaskUrl = `${process.env.PUBLIC_URL}/icons/icons8-телеграм.svg`;

  let footerClass = 'prelaunch';
  if (location.pathname === '/unified-api') {
    footerClass += ' page-unified-api-footer';
  } else if (location.pathname === '/gpu-rental') {
    footerClass += ' page-gpu-rental-footer';
  } else if (location.pathname === '/free-infrastructure' || location.pathname === '/for-developers') {
    footerClass += ' page-free-infrastructure-footer';
  }

  return (
    <section className={footerClass}>
      <div className="footer-background-text" aria-hidden="true">
        <span className="footer-letter-1">S</span>
        <span className="footer-letter-2">W</span>
        <span className="footer-letter-3">A</span>
        <span className="footer-letter-4">R</span>
        <span className="footer-letter-5">M</span>
      </div>

      <div className="container">
        <div className="prelaunch-content">
          <div className="prelaunch-left">
            <nav className="footer-navigation" aria-label="Footer navigation">
              <Link to="/" className="footer-nav-link">
                {t('homeNav')}
              </Link>
              <Link to="/unified-api" className="footer-nav-link">
                {t('unifiedAPINav')}
              </Link>
              <Link to="/gpu-rental" className="footer-nav-link">
                {t('gpuRentalNav')}
              </Link>
              <Link to="/for-developers" className="footer-nav-link">
                {t('freeInfrastructureNav')}
              </Link>
            </nav>
          </div>

          <div className="prelaunch-center">
            <div className="footer-controls">
              <div className="language-toggle-container">
                <label className="language-toggle">
                  <input
                    type="checkbox"
                    checked={language === 'RU'}
                    onChange={onToggleLanguage}
                  />
                  <span className="language-toggle-slider" />
                  <span className="language-toggle-label">{language}</span>
                </label>
              </div>

              <div className="theme-toggle-container">
                <label className="theme-toggle">
                  <input type="checkbox" checked={isLightTheme} onChange={onToggleTheme} />
                  <span className="theme-toggle-slider" />
                  <span className="theme-toggle-label">{t('lightMode')}</span>
                </label>
              </div>
            </div>

            <p className="team-description">{t('footerDescription')}</p>

            <div className="social-links" aria-label="Social links">
              <a
                href="https://t.me/swarmindCEO"
                className="social-link"
                target="_blank"
                rel="noreferrer"
                aria-label="Telegram"
              >
                <span
                  className="social-icon social-icon--telegram"
                  aria-hidden="true"
                  style={{
                    backgroundColor: 'currentColor',
                    WebkitMaskImage: `url(${telegramMaskUrl})`,
                    WebkitMaskRepeat: 'no-repeat',
                    WebkitMaskPosition: 'center',
                    WebkitMaskSize: 'contain',
                    maskImage: `url(${telegramMaskUrl})`,
                    maskRepeat: 'no-repeat',
                    maskPosition: 'center',
                    maskSize: 'contain',
                  }}
                />
              </a>
              <a
                href="https://x.com/"
                className="social-link"
                target="_blank"
                rel="noreferrer"
                aria-label="X"
              >
                <svg className="social-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" fill="currentColor"/>
                </svg>
              </a>
            </div>
          </div>

          <div className="prelaunch-right">
            <div className="prelaunch-cta">
              <button className="cta-button" onClick={onGetAccess} type="button">
                {t('getAccess')}
              </button>
            </div>
            <div className="footer-documents">
              <a href="/data-policy" className="footer-link">
                {t('dataPolicy')}
              </a>
              <span className="footer-separator" aria-hidden="true">
                |
              </span>
              <a href="/user-agreement" className="footer-link">
                {t('userAgreement')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

